import { useState, useEffect } from 'react'
import httpHelper from 'utils/http-helper'
import URL_CONSTANTS from 'constants/url-constants'
import { Method_TYPE } from 'utils/http-helper'
import { convertToIST } from 'utils/formtaDate';

export default function ReportHeader({header}) {
    useEffect(() => {
        getCurrentBatch()
    }, [])

    const [start, setStart] = useState('')
    const [end, setEnd] = useState('')
    const [batchName, setBatchName] = useState('')
    const [isCurrentBatch, setIsCurrentBatch] = useState(false)

    const getCurrentBatch = async () => {

        try {
            const data = await httpHelper(URL_CONSTANTS.GET_CURRENT_BATCH_DETAILS, Method_TYPE.GET);
            setStart(convertToIST(data?.startDate))
            setEnd(convertToIST(data?.endDate))
            setBatchName(data?.name)
            setIsCurrentBatch(data?.isCurrent)
            localStorage.setItem('currentBatch', JSON.stringify(data))
        }
        catch (err) {
            console.error('Error fetching samithi details:', err);
            setSamithis([])
        }
    }
    return (
        <div className="p-4 text-center border-border bg-white bg-card border !rounded-lg shadow-spiritual-sm border-b-0 !rounded-bl-none !rounded-br-none relative">
            <h4 className="text-lg font-bold pb-1">TamilNadu Prasanthi Seva - {header}</h4>
            <p className="text-sm">
                <span className="font-bold">{batchName}</span> (<span className="font-bold">{start} - {end}</span>)<span className={isCurrentBatch ? 'text-green-500 font-bold table-ribbon-badge' : ''}>{isCurrentBatch && 'Current Batch'}</span>
            </p>
        </div>
    );
}
